import jsonp from "../../assets/js/http";
import _com from "../../assets/js/common";

const state = {
	roomData: {},
	stateData: {},
};

const getters = {
	getRoomDetail(state: any) {
		return state.roomData;
	},
	getStatus(state: any) {
		return state.stateData;
	},
};

const actions = {
	getRoomDetailAsync(context: any, id: string) {
		//获取购物车数据
		return new Promise((resolve, reject) => {
			const callback = 'newBoFangBase'
			let url = `${process.env.VUE_APP_URI_CDNDOMAIN}/live/api/out/room/newBoFangBase/${id}/${Math.floor(new Date().getTime() / 5000)}/${callback}?t=${new Date().getTime()}`;
			jsonp(url, {
				id: id,
				// jsonp: callback,
				jsonpcallback:callback
			}).then((data: any) => {
				resolve(data);
				context.commit("setRoomDetail", data);
			});
		});
	},
	getStatusAsync(context: any, data: any) {
		context.commit("setStatus", data);
	},
};

const mutations = {
	setRoomDetail(state: any, res: any) {
		state.roomData = res;
	},
	setStatus(state: any, res: any) {
		state.stateData = res;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
